module.exports = __webpack_public_path__ + "static/media/Landing_01.f0903669.png";